import { sendRequest } from "../sendRequest";

export const getWalletInfo = () => {
  const queryKey = ["wallet", "info"];
  const queryFunction = () =>
    sendRequest("get", `/influencer/wallet`).then((res) => res.data);
  return { queryKey, queryFunction };
};
